import { client as native } from './client/node';
import { RequestType, } from './_types';
export const gotenberg = (url, client, config) => {
    let instance;
    if (typeof client === 'object' && 'post' in client) {
        instance = client;
    }
    else if (typeof client === 'function') {
        if (/^class\s/.test(Function.prototype.toString.call(client))) {
            instance = new client(config);
        }
        else {
            instance = client(config);
        }
    }
    else {
        instance = native(config || client);
    }
    return (source) => ({
        type: RequestType.Undefined,
        url: url.toString(),
        client: instance,
        source,
        fields: {},
    });
};
